export const BRAND = {
    name: "Mariachi Mexicanísimo",
    phone: "3225225139",
    phoneDisplay: "+57 322 522 5139",
    email: "Felipehurtado321@gmail.com",
    city: "Armenia, Quindío",
    country: "Colombia",
    street: "Cra 15 #11",
    address: "Cra 15 #11, Armenia, Quindío",
    whatsappMsg: "Hola! Me gustaría cotizar una serenata con Mariachi Mexicanísimo.",
};

// Coordenadas exactas de la dirección en Armenia (confirmadas por el cliente
// en Google Maps), para que el mapa y "Cómo llegar" apunten al punto preciso
// en vez de depender de que el texto de la dirección se geocodifique bien.
export const LOCATION = {
    lat: 4.5371025,
    lng: -75.6694158,
};

export const SOCIAL = {
    instagram: "https://www.instagram.com/mariachimexicanisimoarmenia/?hl=es",
    facebook: "https://www.facebook.com/Mariachiarmeniamexicanisimo/",
    tiktok: "https://www.tiktok.com/@andresmexicanisimo",
};

export const whatsappUrl = (msg) =>
    `https://wa.me/57${BRAND.phone}?text=${encodeURIComponent(msg || BRAND.whatsappMsg)}`;

export const NAV_LINKS = [
    { id: "inicio", label: "Inicio" },
    { id: "nosotros", label: "Nosotros" },
    { id: "servicios", label: "Servicios" },
    { id: "galeria", label: "Galería" },
    { id: "musicos", label: "Músicos" },
    { id: "contacto", label: "Contacto" },
];

export const SERVICIOS = [
    {
        id: "basico",
        name: "Show Básico",
        tagline: "Serenata tradicional",
        badge: "Más pedido",
        features: [
            "9 Canciones a elección",
            "Show de zapateo",
            "Voz masculina y femenina",
            "Tarjeta postal con dedicatoria",
            "Recordatorio mexicano",
            "Equipo de sonido profesional",
            "Transporte incluido",
        ],
    },
    {
        id: "especial",
        name: "Show Especial",
        tagline: "Una hora de fiesta",
        badge: "Recomendado",
        featured: true,
        features: [
            "15 Canciones · 1 hora de show",
            "Zapateo · Bailable · Mariachi Loco",
            "Voz masculina y femenina",
            "Tarjeta postal con dedicatoria",
            "Recordatorio mexicano",
            "Equipo de sonido profesional",
            "Transporte incluido",
        ],
    },
    {
        id: "banda",
        name: "Show Banda Mexicana",
        tagline: "Gran formato",
        badge: "Premium",
        features: [
            "Una hora de show en vivo",
            "Voz masculina y femenina",
            "8 Integrantes en tarima",
            "Excelente presentación personal",
            "Equipo de sonido profesional",
            "Transporte incluido",
        ],
    },
];

// Fotos reales de clientes/eventos (antes eran fotos de stock de Unsplash).
export const GALERIA = [
    "/images/galeria/cliente3.jpg",
    "/images/galeria/cliente2.jpg",
    "/images/galeria/cliente1.jpg",
    "/images/galeria/cliente4.jpg",
];

export const MUSICOS = [
    {
        name: "Andrés Grajales",
        role: "Acordeón",
        icon: "accordion",
        // Foto del instrumento en MODO DIURNO / MODO NOCTURNO (fotos propias del cliente)
        instrument_img_day: "/images/musicos/dia/acordeon.jpg",
        instrument_img_night: "/images/musicos/noche/acordeon.jpg",
    },
    {
        name: "Fabián",
        role: "Trompeta",
        icon: "trumpet",
        instrument_img_day: "/images/musicos/dia/trompeta.jpg",
        instrument_img_night: "/images/musicos/noche/trompeta.jpg",
    },
    {
        name: "Paola",
        role: "Cantante",
        icon: "mic",
        instrument_img_day: "/images/musicos/dia/cantante.jpg",
        instrument_img_night: "/images/musicos/noche/cantante.jpg",
    },
    {
        name: "One",
        role: "Guitarrón",
        icon: "guitar",
        instrument_img_day: "/images/musicos/dia/guitarron.jpg",
        instrument_img_night: "/images/musicos/noche/guitarron.jpg",
    },
    {
        name: "Martín",
        role: "Vihuela",
        icon: "guitar",
        instrument_img_day: "/images/musicos/dia/vihuela.jpg",
        instrument_img_night: "/images/musicos/noche/vihuela.jpg",
    },
    {
        name: "Javier",
        role: "Cantante",
        icon: "mic",
        instrument_img_day: "/images/musicos/dia/cantante2.jpg",
        instrument_img_night: "/images/musicos/noche/cantante2.jpg",
    },
];

export const HERO_BG = "/images/fondo.jpg";
export const OWNER_IMG = "/images/inicio.jpg";
export const OWNER_NAME = "Felipe Hurtado";
export const OWNER_ROLE = "Director Musical · Mariachi Mexicanísimo";
// Demo de serenata (teaser 30s). Reemplaza con tu propia grabación.
export const AUDIO_DEMO_URL = "https://assets.mixkit.co/music/preview/mixkit-spanish-guitar-ambient-ballad-562.mp3";
export const AUDIO_DEMO_TITLE = "Demo · Serenata tradicional";

// YouTube video del mariachi
export const YOUTUBE_ID = "B0WcoY0lMRU";
// Es un YouTube Short (video vertical) — VideoLightbox usa esto para no
// mostrarlo diminuto dentro de una caja panorámica 16:9.
export const YOUTUBE_VERTICAL = true;
export const YOUTUBE_URL = `https://www.youtube.com/watch?v=${YOUTUBE_ID}`;
export const YOUTUBE_EMBED = `https://www.youtube.com/embed/${YOUTUBE_ID}?autoplay=1&rel=0`;
export const YOUTUBE_THUMB = `https://img.youtube.com/vi/${YOUTUBE_ID}/maxresdefault.jpg`;
export const YOUTUBE_TITLE = "Mariachi Mexicanísimo en vivo";

export const VALUES = [
    {
        stat: "+5",
        label: "Años",
        title: "de trayectoria",
        desc: "Una historia musical consolidada en el Eje Cafetero, con cientos de serenatas hechas con alma.",
        img: "https://images.unsplash.com/photo-1654576205088-6503ad4ffb72?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
    },
    {
        stat: "+100",
        label: "Canciones",
        title: "en repertorio",
        desc: "Rancheras, boleros, baladas y vallenatos. Tu tema favorito, preparado para tu momento.",
        img: "https://images.unsplash.com/photo-1729638276657-0a0978e66d38?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
    },
    {
        stat: "24/7",
        label: "Atención",
        title: "inmediata",
        desc: "Respondemos en minutos por WhatsApp. Confirmamos disponibilidad al instante, a cualquier hora.",
        img: "https://images.unsplash.com/photo-1714972383483-2ef4a41f2ef4?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
    },
    {
        stat: "+15",
        label: "Municipios",
        title: "de cobertura",
        desc: "Presencia en más de 15 municipios del Eje Cafetero, entre Quindío, Risaralda y Caldas.",
        img: "https://images.unsplash.com/photo-1515113312892-c9f41cf5582e?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
    },
];

// Intro sonoro que se reproduce al primer clic/interacción del usuario.
// Reemplaza por tu propio clip "Mexicanísimo!" en mariachi si tienes uno.
export const INTRO_SOUND_URL = "https://assets.mixkit.co/active_storage/sfx/2869/2869-preview.mp3";
